// Core component styles
const coreStyles = {
    container: {
        height: '100%',
        width: '100%',
    },
};

/**
 * Helper method to get styles for the Power BI
 * @param {Object} contextStyles - Custom styles for the PowerBI component
 */
const getStyles = (contextStyles = {}) => {
    return {
        container: {
            ...coreStyles.container,
            ...contextStyles.container,
        },
    };
};

export default getStyles;
